module.exports = __webpack_public_path__ + "img/portrait-070.2663f53e.jpg";